<template>
  <div>
    <div class="banner-wrap" v-if="bannerList.length">
      <div class="certificate-query-wrapper">
        <el-button
          class="certificate-query"
          @click="() => $refs.certificateQueryDialog.show()"
        >
        </el-button>
      </div>
      <el-carousel height="500px">
        <el-carousel-item
          v-for="item in bannerList"
          :key="item.id"
          style="cursor: pointer; height: 500px"
        >
          <img
            class="el-carousel__img"
            style="width: 100%"
            :src="item.imgUrl"
            alt=""
            @click="jump(item)"
          />
        </el-carousel-item>
      </el-carousel>
    </div>
    <div class="course-wrapper" v-loading.fullscreen.lock="loading">
      <div class="certificate-query-wrapper" v-if="!bannerList.length">
        <el-button
          class="certificate-query"
          @click="() => $refs.certificateQueryDialog.show()"
        >
        </el-button>
      </div>

      <div class="course">
        <div class="course-item" v-for="item in courses" :key="item.id">
          <div class="course-item__thumb-wrapper">
            <span class="course-item__tag" :style="{ background: item.color }">
              {{ item.text }}
            </span>
            <img
              class="course-item__thumb"
              :src="item.thumbImgUrl"
              alt=""
              @click="onDetail(item)"
            />
          </div>
          <h3 class="course-item__title" @click="onDetail(item)">
            {{ item.title }}
          </h3>
          <p class="course-item__p" v-show="item.customTextA">
            {{ item.customTextA }}
          </p>
          <p class="course-item__p" v-show="item.customTextB">
            {{ item.customTextB }}
          </p>
        </div>
      </div>
      <div style="text-align: center">
        <el-pagination
          background
          layout="prev, pager, next"
          :total="total"
          :current-page.sync="pageNum"
          :page-size.sync="pageSize"
          @current-change="onCurrentPageChange"
        />
      </div>

      <div
        class="cooperation-wrapper"
        @mouseenter="pauseScroll"
        @mouseleave="startScroll"
      >
        <div
          :class="['cooperation']"
          :style="{ transform: `translateX(${-offset}px)` }"
        >
          <div
            v-for="(item, index) in visibleImages"
            :key="index"
            class="cooperation-item"
          >
            <img class="cooperation-item__img" :src="item.imgUrl" alt="" />
          </div>
        </div>
      </div>
    </div>

    <CertificateQueryDialog ref="certificateQueryDialog" />
  </div>
</template>

<script>
import {
  getCourses,
  getCooperationList,
  getCourseBannerList,
} from "@/api/course";
import dayjs from "dayjs";
import CertificateQueryDialog from "./components/CertificateQueryDialog.vue";

export default {
  name: "Courses",
  components: { CertificateQueryDialog },

  data() {
    return {
      bannerList: [],

      competition: {}, //赛事基本信息
      courses: [],
      loading: false,

      total: 0,
      pageNum: 1,
      pageSize: 12,

      cooperations: [],
      offset: 0,
      scrollInterval: null,
    };
  },
  created() {
    this.getCourses();
    this.getCooperationList();
    this.getCourseBannerList();
  },
  beforeDestroy() {
    clearInterval(this.scrollInterval);
  },
  computed: {
    visibleImages({ cooperations }) {
      if (cooperations.length > 10) {
        return [...cooperations, ...cooperations];
      } else {
        return cooperations;
      }
    },
  },

  methods: {
    stopScroll() {
      clearInterval(this.scrollInterval);
    },
    pauseScroll() {
      this.stopScroll();
    },
    startScroll() {
      this.scrollInterval = setTimeout(() => {
        this.offset += 1;
        if (this.offset >= this.cooperations.length * 120) {
          this.offset = 0;
        }
        this.startScroll();
      }, 16);
    },
    getCourseBannerList() {
      getCourseBannerList().then((res) => {
        this.bannerList = res.data;
      });
    },
    getCooperationList() {
      getCooperationList().then(({ data }) => {
        this.cooperations = data;
        if (data.length > 10) {
          setTimeout(() => {
            this.startScroll();
          }, 16);
        }
      });
    },
    onDetail({ id: courseId }) {
      this.$router.push({ name: "courseDetail", query: { courseId } });
    },
    onCurrentPageChange() {
      this.getCourses();
    },
    getCourses() {
      const { pageNum, pageSize } = this;
      this.loading = true;
      getCourses({
        pageNum,
        pageSize,
      })
        .then(({ rows = [], total = 0 }) => {
          this.courses = rows.map((item) => {
            const { text, color } = this.calculateCourseTag(item);
            return {
              text,
              color,
              ...item,
            };
          });
          this.total = total;
        })
        .finally(() => {
          this.loading = false;
        });
    },

    jump(item) {
      if (!item.targetUrl) return;
      window.open(item.targetUrl, "_blank");
    },
    calculateCourseTag({
      licenseCreateTime,
      openSaleStartTime,
      openSaleEndTime,
    }) {
      let color = "";
      let text = "";

      if (licenseCreateTime === null) {
        const now = dayjs().valueOf();
        const start = dayjs(openSaleStartTime).valueOf();
        const end = dayjs(openSaleEndTime).valueOf();
        if (now < start) {
          text = "未开放";
          color = "#DF8D46";
        } else if (now > end) {
          text = "已结束";
          color = "#909399";
        } else {
          text = Number.isNaN(end)
            ? ""
            : `剩余${dayjs(end).diff(now, "day")}天`;
          color = "#DF8D46";
        }
      } else {
        text = "我的课程";
        color = "#00b1a2";
      }
      return {
        color,
        text,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.banner-wrap {
  position: relative;

  .certificate-query {
    width: 176px;
    height: 56px;
    border: 0 none;
    background: url("../../assets/certificate_query.png");
    background-size: cover;

    &-wrapper {
      position: absolute;
      left: 0;
      right: 0;
      bottom: 0;
      width: 1180px;
      height: 100px;
      margin: auto;
      z-index: 3;
    }
  }
}

.certificate-query {
  width: 176px;
  height: 56px;
  border: 0 none;
  background: url("../../assets/certificate_query.png");
  background-size: cover;

  &-wrapper {
    width: 1180px;
    margin: 0 auto 50px;
  }
}

::v-deep .el-carousel__indicators {
  z-index: 10;
}

.course {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  width: 1200px;
  margin: 0 auto;
  color: #fff;

  &::after {
    content: "";
    width: 373px;
  }

  &-wrapper {
    padding: 30px 0 65px;

    background: url("../../assets/detail-bg.png");
    background-size: cover;
  }

  &-item {
    box-sizing: border-box;
    width: 373px;
    height: 351px;
    padding: 20px;
    background: #0a2b51;
    border-radius: 20px;
    border: 1px solid #046bde;
    margin-bottom: 30px;

    &__tag {
      position: absolute;
      left: 0;
      top: 0;
      width: 100px;
      height: 40px;
      line-height: 40px;
      border-radius: 15px 5px 5px 5px;
      text-align: center;
      font-weight: 600;
      font-size: 16px;
    }

    &__thumb {
      width: 333px;
      height: 177px;
      border-radius: 15px;
      object-fit: cover;

      &-wrapper {
        position: relative;
        cursor: pointer;
      }
    }

    &__title {
      margin: 8px 0;
      font-weight: 600;
      font-size: 20px;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
      cursor: pointer;
    }

    &__p {
      font-size: 16px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      &:nth-of-type(1) {
        margin-bottom: 10px;
      }
    }
  }
}

// @keyframes move {
//   0% {
//     transform: translate(0);
//   }
//   50% {
//     transform: translate(-120px);
//   }
//   100% {
//     transform: translate(0);
//   }
// }

.cooperation {
  // width: 1180px;
  color: #fff;
  white-space: nowrap;
  vertical-align: top;

  &.animation {
    animation: move 6s linear 1s infinite;
  }

  &:hover {
    animation-play-state: paused;
  }

  &-wrapper {
    width: 1180px;
    margin: 50px auto 0;
    overflow-x: hidden;
  }

  &-item {
    display: inline-block;
    width: 100px;
    height: 100px;
    line-break: 100px;
    border-radius: 10px;
    border: 1px solid #046bde;
    margin-right: 20px;
    overflow: hidden;
    background: #fff;
    text-align: center;

    &__img {
      width: 100%;
      height: auto;
      object-fit: cover;
    }
  }
}
.el-carousel__img {
  height: 500px;
  object-fit: cover;
}
</style>
